import React from 'react';
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import { LoginPage, HomePage, HBRHomePage, BarragemManchas, GISTMPage } from '../pages';
import BarragemApp from '../pages/barragem/barragemApp';
import { UserProvider } from '../context';

export const AppRoutes: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<Navigate to="/login" />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/app/*" element={<LoggedApp />} />
      </Routes>
    </BrowserRouter>
  );
};

const LoggedApp: React.FC = () => {
  return (
    <UserProvider>
      <Routes>
        <Route path="/*" element={<Navigate to="/app/home/" />} />
        <Route path="/hbr/*" element={<HBRApp />} />
        <Route path="/home/*" element={<HomePage />} />
        <Route path="/home/:id" element={<HomePage />} />
        <Route path="/:barragem/*" element={<BarragemApp />} />
        <Route path="/manchas/:barragem/*" element={<BarragemManchas />} />
        <Route path="/GISTM/:barragem/*" element={<GISTMPage />} />
      </Routes>
    </UserProvider>
  );
};

const HBRApp: React.FC = () => {
  return (
    <Routes>
      <Route path="/*" element={<Navigate to="/app/hbr/home/home" />} />
      <Route path="/home/:view" element={<HBRHomePage />} />
    </Routes>
  );
};